<template>
  <div>
    <div class="download-tab">
      <ul class="nav nav-tabs" id="myTab">
        <li>
          <router-link :to="{ name: 'download' }">
            <i class="iconfont icon-windows"></i>
            <span class="client-name">Windows</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'downloadAndroid' }">
            <i class="iconfont icon-android"></i>
            <span class="client-name">Android</span>
          </router-link>
        </li>
        <li class="active">
          <a>
            <i class="iconfont icon-ios1"></i>
            <span class="client-name">iPhone/iPad</span>
          </a>
        </li>
        <li>
          <router-link :to="{ name: 'downloadWindowsSync' }">
            <i class="iconfont icon-windows-tb"></i>
            <span class="client-name">Windows同步端(测试版)</span>
          </router-link>
        </li>
        <!-- <li>
          <router-link :to="{ name: 'downloadIphoneSync' }">
            <i class="iconfont icon-ios-tb"></i>
            <span class="client-name">Mac同步端</span>
          </router-link>
        </li> -->
      </ul>
    </div>
    <div class="download clearfix">
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade in active" id="pc">
          <div class="pic">
            <img src="@/assets/images/dbg-ios.png" />
          </div>
          <div class="detail">
            <h1>睿客云盘iPhone/iPad版</h1>
            <h2>
              1TB超大存储空间，
              <br />手机相册、视频 一键备份到云盘
            </h2>
            <div class="btnbox">
              <button
                class="btn btn-primary"
                type="button"
                @click="goToAppStore"
              >
                访问App Store
              </button>
            </div>
            <div class="info">
              <ul>
                <li>适应系统：iOS9.0及以上版本</li>
                <li>更新时间：{{ this.releases.released_at }}</li>
                <li>
                  版本：{{ this.releases.version_no }}
                  <router-link :to="{ name: 'updatelogIphone' }"
                    >查看详细</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clientReleases } from "@/api/common/index";
export default {
  name: "Download",
  data() {
    return {
      releases: {
        terminal_name: "",
        download_install: "",
        download_unzip: "",
        created_at: "",
        version_no: "",
      },
    };
  },
  created() {
    this.$store.commit("SET_THEME", "客户端下载");
    this.clientReleases();
  },
  methods: {
    goToAppStore() {
      window.open(
        "https://apps.apple.com/cn/app/%E7%9D%BF%E5%AE%A2%E4%BA%91%E7%9B%98/id1436434117?ign-mpt=uo%3D4"
      );
    },
    // 获取PC版本等信息
    clientReleases() {
      clientReleases({
        offset: 0,
        limit: 1,
        terminal_type: "3",
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.releases = res.entity[0];
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style scoped>
</style>